// extracted by mini-css-extract-plugin
export default {"headingTag":"page-heading_headingTag__q+uV8"};